/**
 * useCreateTransaction Hook
 *
 * 거래 생성 Hook
 * - 공유 transactionRepository 싱글톤 사용
 * - 로딩/에러 상태 관리
 * - 성공 시 홈으로 리다이렉트
 *
 * @why 인스턴스를 매번 new로 만들지 않고 '../repositories' 싱글톤을 사용해
 * 메모리 누수 방지 + 테스트 가능성 확보.
 */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { TransactionInput } from '../types/Transaction'
import { transactionRepository } from '../repositories'

export function useCreateTransaction() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const createTransaction = async (input: TransactionInput) => {
    setLoading(true)
    setError(null)

    try {
      const newTransaction = await transactionRepository.create(input)

      // 성공: 홈으로 이동
      navigate('/')

      return newTransaction
    } catch (err) {
      const message = err instanceof Error ? err.message : '거래 등록에 실패했습니다'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    createTransaction,
    loading,
    error,
  }
}
